module.exports = __webpack_public_path__ + "img/galerie-29.aaf95e01.jpg";